export const AUDIENCE_PAGE_SIZE = 30;

export const AUDIENCE_TYPE_OPTIONS = [
  { value: "category", label: "Category" },
  { value: "platform", label: "Platform" },
  { value: "manual", label: "Custom" },
];

export const ALL_AUDIENCE_TYPES = AUDIENCE_TYPE_OPTIONS.map((option) => option.value);

export const AUDIENCE_SORT_OPTIONS = [
  { value: "fit_score", label: "Best fit" },
  { value: "create_date", label: "Date created" },
  { value: "videos_synced_at", label: "Date synced" },
  { value: "creators", label: "Creators" },
  { value: "videos", label: "Videos" },
];

export const AUDIENCE_PLATFORM_FILTER_OPTIONS = [
  { value: "", label: "All platforms" },
  { value: "instagram", label: "Instagram" },
  { value: "youtube", label: "YouTube" },
  { value: "tiktok", label: "TikTok" },
];

const PLATFORM_LABELS = {
  instagram: "Instagram",
  youtube: "YouTube",
  tiktok: "TikTok",
};

export function getPlatformLabel(platform) {
  if (!platform) return "";
  return (
    PLATFORM_LABELS[platform] ||
    platform.charAt(0).toUpperCase() + platform.slice(1)
  );
}

export function getAudienceDisplayName(audience) {
  if (audience?.name?.trim()) return audience.name.trim();
  if (audience?.category_name?.trim()) return audience.category_name.trim();
  if (audience?.audience_type === "platform") {
    const platform = audience.category_platform || audience.platform;
    const label =
      PLATFORM_LABELS[platform] ||
      (platform ? platform.charAt(0).toUpperCase() + platform.slice(1) : "Platform");
    return `Best of ${label}`;
  }
  return "Untitled audience";
}

/** Brand hash for audience list API calls; omit when brand is missing or not in current project. */
export function resolveAudienceListBrandHash(currentProject, currentBrand, brands) {
  if (!currentProject?.hash || !currentBrand?.hash) return null;
  const match = brands.find(
    (brand) => brand.hash === currentBrand.hash && brand.project_hash === currentProject.hash
  );
  return match?.hash ?? null;
}
